var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M5.67133 0.331177L0.276753 6.65989C0.0405618 6.93758 0.0405618 7.3875 0.276753 7.6659C0.512944 7.9436 0.89658 7.9436 1.13277 7.6659L6.09931 1.83918L11.0659 7.6652C11.302 7.9429 11.6857 7.9429 11.9225 7.6652C12.1587 7.3875 12.1587 6.93688 11.9225 6.65918L6.52794 0.330476C6.29419 0.0570423 5.90453 0.0570424 5.67133 0.331177Z",
    fill: "#05275D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.0dcb5365f11d3c2c8d1f27868eade8fd.svg";
export { ForwardRef as ReactComponent };